// extracted by mini-css-extract-plugin
export default {"activeSwitch__container--readyToActivate":"style-module__activeSwitch__container--readyToActivate___HY6s_","pulsate":"style-module__pulsate___mXrMB"};